import {LISTING_SECTION_IDS} from '../common/listingSections.js'
import {
  PATHS as sharedPaths,
  PATHS_BY_LISTING_SECTION_ID as sharedPathsByListingSectionId,
  STOCK_PATHS_BY_LISTING_SECTION_ID as sharedStockPathsByListingSectionId
} from '../common/paths.js'

// Define only the paths that are different from the common ones
export const PATHS = {
  ...sharedPaths,
  ADS_LIST_AUTOCARAVANS_AND_TRAILERS: '/autocaravanas-y-remolques/',
  ADS_LIST_CLASSIC_AND_COMPETITION: '/clasicos-competicion/',
  ADS_LIST_KM0: '/km-0/',
  ADS_LIST_NEW: '/nuevo/km-0/',
  ADS_LIST_NO_LICENSE: '/sin-carnet/',
  ADS_LIST_RENTING: '/renting/',
  ADS_LIST_SECOND_HAND: '/segunda-mano/',
  ADS_LIST_VANS_AND_COMMERCIAL: '/vehiculos-industriales/'
}

// Define only the paths by listing section id that are different from the common ones
export const PATHS_BY_LISTING_SECTION_ID = {
  ...sharedPathsByListingSectionId,
  [LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES]: PATHS.ADS_LIST_AUTOCARAVANS_AND_TRAILERS,
  [LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES]: PATHS.ADS_LIST_CLASSIC_AND_COMPETITION,
  [LISTING_SECTION_IDS.KM0_VEHICLES]: PATHS.ADS_LIST_KM0,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: PATHS.ADS_LIST_NEW,
  [LISTING_SECTION_IDS.NO_LICENSE_VEHICLES]: PATHS.ADS_LIST_NO_LICENSE,
  [LISTING_SECTION_IDS.RENTING_VEHICLES]: PATHS.ADS_LIST_RENTING,
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND,
  [LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES]: PATHS.ADS_LIST_VANS_AND_COMMERCIAL
}

// Define only the stock paths by listing section id that are different from the common ones
export const STOCK_PATHS_BY_LISTING_SECTION_ID = {
  ...sharedStockPathsByListingSectionId
}
